import React from 'react';
import { CalendarDays, Calendar as CalendarIcon, View } from 'lucide-react';

export type CalendarView = 'day' | 'week' | 'month';

interface ViewSwitcherProps {
  currentView: CalendarView;
  onViewChange: (view: CalendarView) => void;
}

export const ViewSwitcher: React.FC<ViewSwitcherProps> = ({
  currentView,
  onViewChange,
}) => {
  const views: { value: CalendarView; label: string; icon: React.ReactNode }[] = [
    { value: 'day', label: 'Day', icon: <View className="w-4 h-4" /> },
    { value: 'week', label: 'Week', icon: <CalendarDays className="w-4 h-4" /> },
    { value: 'month', label: 'Month', icon: <CalendarIcon className="w-4 h-4" /> },
  ];

  return (
    <div className="inline-flex rounded-lg shadow-sm" role="group">
      {views.map(({ value, label, icon }) => (
        <button
          key={value}
          onClick={() => onViewChange(value)}
          className={`
            inline-flex items-center px-4 py-2 text-sm font-medium
            first:rounded-l-lg last:rounded-r-lg
            focus:z-10 focus:ring-2 focus:ring-blue-500 focus:outline-none
            ${
              currentView === value
                ? 'bg-blue-500 text-white hover:bg-blue-600'
                : 'bg-white text-gray-900 border border-gray-200 hover:bg-gray-100'
            }
            ${
              currentView !== value
                ? 'border-r-0 last:border-r hover:z-10'
                : ''
            }
            transition-colors
          `}
        >
          <span className="mr-2">{icon}</span>
          {label}
        </button>
      ))}
    </div>
  );
};